import { useEditorState } from "@tiptap/react"
import { defaultUiState } from "@/tiptap/extensions/ui-state-extension";

export function useUiEditorState(editor) {
  return (useEditorState({
    editor,
    selector: ({ editor }) => {
      if (!editor) return defaultUiState

      const state = editor.storage.uiState
      if (!state) {
        console.warn(
          "Editor storage uiState is not initialized. Ensure you have the uiState extension added to your editor."
        )
        return defaultUiState
      }

      return { ...defaultUiState, ...state }
    },
  }) ?? defaultUiState);
}

export default useUiEditorState
